export const contactsData = {
    email: 'vasogoma@gmail.com',
    phone: 'Download CV for contact details',
    address: 'Zurich, Switzerland',

    sheetAPI: ''
}